module.exports = __webpack_public_path__ + "static/media/Arrow-right.06e6d4de.svg";